var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex align-center az-gap-small" },
    [
      _c(
        "TranscriptRingGauge",
        {
          attrs: {
            value: _vm.ringValue,
            max: 100,
            color: _vm.sentimentoHex,
            "track-color": _vm.sentimentoTint,
            size: _vm.size
          }
        },
        [
          _vm.hasSentiment
            ? _c(
                "span",
                {
                  staticClass:
                    "transcript-sentiment-gauge__value az-text-primary",
                  style: _vm.valueStyle
                },
                [_vm._v(" " + _vm._s(_vm.nota !== null ? _vm.nota : "-") + " ")]
              )
            : _c(
                "span",
                { staticClass: "transcript-sentiment-gauge__value" },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: "mdi-help-circle",
                      size: _vm.emptyIconSize,
                      color: "#BEBEBE"
                    }
                  })
                ],
                1
              )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "d-flex flex-column",
          staticStyle: { "min-width": "0" }
        },
        [
          _c(
            "span",
            {
              staticClass: "font-semibold text-truncate",
              class: _vm.showScale ? "az-size-16" : "az-size-14",
              style: { color: _vm.labelColor }
            },
            [_vm._v(" " + _vm._s(_vm.displayLabel) + " ")]
          ),
          _vm.showScale && _vm.hasSentiment
            ? _c("span", { staticClass: "az-text-small" }, [
                _vm._v(" Score: " + _vm._s(_vm.nota) + "/100 ")
              ])
            : _vm._e(),
          _vm.engajamentoLabel
            ? _c("span", { staticClass: "az-text-small text-truncate" }, [
                _vm._v(" Engajamento: " + _vm._s(_vm.engajamentoLabel) + " ")
              ])
            : _vm._e(),
          !_vm.hasSentiment
            ? _c("span", { staticClass: "az-text-small" }, [
                _vm._v(" Sentimento ainda não disponível ")
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }